import { genericRoute } from 'utils/routeUtils';

import CricketHomePage from './containers/CricketHomePage';
import CricketNav from './nav/CricketNav';

export default genericRoute(CricketHomePage, CricketNav, 'cricket');



// WEBPACK FOOTER //
// ./modules/Cricket/routes.js